<template>
    <div>
        <div class="whiteBox">
            <el-tabs v-model="activeName" @tab-click="handleCurrentChange(1)">
                <el-tab-pane v-for="item in stautsList" style="position: relative;" :key="item.dictValue" :name="item.dictValue">
                    <span  slot="label">
                        {{ item.dictLabel }}
                        <span v-if="item.num" class="tab-badge">{{ item.num }}</span>
                    </span>
                </el-tab-pane>
            </el-tabs>
            <div>
                <el-input v-model="form.materialCode" :placeholder="$t('view.物资编码')" style="width: 200px;" size="mini"></el-input>
                <el-input v-model="form.materialName" :placeholder="$t('view.物资名称')" style="width: 200px;margin: 0 10px;" size="mini"></el-input>
                <el-button size="mini" type="primary" @click="handleCurrentChange(1)">{{ $t('view.搜索') }}</el-button>
                <el-button size="mini" style="margin: 0 10px;" @click="resetting">{{ $t('view.重置') }}</el-button>
            </div>
        </div>
        <div style="margin-top: 10px;" class="whiteBox">
            <div style="display: flex;margin-bottom: 10px;" v-if="activeName==0||activeName==4">
                <el-button size="mini" type="primary" @click="supplierMaterialApproveExport">{{ $t('view.下载模板') }}</el-button>
                <el-upload  action="#" :show-file-list="false" :http-request="importFile"  accept=".xlsx" style="margin:0 10px">
                    <el-button type="primary" size="mini">{{ $t('view.导入') }}</el-button>
                </el-upload>
                <el-button size="mini"  type="primary" @click="batch">{{ $t('view.批量提交') }}</el-button>
            </div>
            <el-table header-row-class-name="tableHeader" :data="tableData" style="width: 1010px" border @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="60" align="center" :label="$t('view.序号')"></el-table-column>
                <el-table-column align="center" width="80" show-overflow-tooltip :label="$t('view.来源')">
                    <template slot-scope="scope">
                        {{ getStatus('sys_supplier_material_approve_source',scope.row.source) }}
                    </template>
                </el-table-column>
                <el-table-column prop="title" align="center" show-overflow-tooltip :label="$t('view.合同名称/招标项目')">
                </el-table-column>
                <el-table-column prop="materialName" align="center" show-overflow-tooltip :label="$t('view.物资名称')">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip :label="$t('view.商品信息')">
                    <template slot-scope="scope">
                       <span @click="Det(scope.row)" style="color: #0091FF;border-bottom: solid 1px #0091FF;padding-bottom: 2px;cursor: pointer;">{{ scope.row.status!=0&&scope.row.status!=4? $t('view.查看信息'): $t('view.完善信息') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="procurementManagerUserName" align="center" show-overflow-tooltip :label="$t('view.采购/招标负责人')">
                </el-table-column>
                <el-table-column align="center" width="80" show-overflow-tooltip :label="$t('view.状态')">
                    <template slot-scope="scope">
                        {{ getStatus('stautsList',scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column prop="approvalOpinion" width="100" v-if="activeName==4" align="center" show-overflow-tooltip :label="$t('view.驳回原因')">
                </el-table-column>
                <el-table-column prop="sectionName" width="80" v-if="activeName==4||activeName==0" align="center" show-overflow-tooltip :label="$t('view.操作')">
                    <template slot-scope="scope">
                        <div style="background: #44D7B6;border-radius: 4px;color: #FFFFFF;font-size: 14px;cursor: pointer;" @click="batchSubmit(scope.row.id)">{{ $t('view.提交') }}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: center;margin-top: 20px;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
        <el-dialog class="HandlingMatters" :close-on-click-modal="false" :visible.sync="visibleOpen" width="760px" :title="DetForm.status!=0? $t('view.物资名称-信息查看'): $t('view.物资名称-信息填写')">
            <el-form label-position="top" ref="form" label-width="100px" :disabled="DetForm.status!=0&&DetForm.status!=4" :model="DetForm" :rules="rules">
                <div class="flex30">
                    <el-form-item prop="materialCode" :label="$t('view.物资编码')">
                        <div style="display: flex;">
                            <el-input v-model="DetForm.materialCode" disabled ></el-input>
                            <el-button  type="primary" size="mini" @click="openMaterialSelect" style="margin-left: 8px">{{ $t('view.选择') }}</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item prop="specificationName" :label="$t('view.规格')">
                        <el-input v-model="DetForm.specificationName" :placeholder="$t('view.请输入')"></el-input>
                    </el-form-item>
                    <el-form-item prop="model" :label="$t('view.型号')">
                        <el-input v-model="DetForm.model" :placeholder="$t('view.请输入')"></el-input>
                    </el-form-item>
                    <el-form-item prop="brandName" :label="$t('view.品牌')">
                        <el-input v-model="DetForm.brandName" :placeholder="$t('view.请输入')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('view.是否进口')" prop="isImport" class="switchBox">
                        <el-radio-group v-model="DetForm.isImport">
                            <el-radio v-for="item in sys_supplier_material_import" :key="item.dictValue" :label="item.dictValue">{{ item.dictLabel }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="masterUnit" :label="$t('view.计量单位')">
                        <el-input v-model="DetForm.masterUnit" :placeholder="$t('view.请输入')"></el-input>
                    </el-form-item>
                </div>
                <el-form-item prop="details" :label="$t('view.商品介绍')">
                    <el-input style="width: 100%" type="textarea" :rows="2" v-model="DetForm.details" :placeholder="$t('view.请输入')"></el-input>
                </el-form-item>
                <el-form-item prop="mainImageFileList" :label="$t('view.商品主图(包含图片、3D建模、视频等)')">
                  <template #label>
                    <span style="color: red;">{{$t('view.商品主图(包含图片、3D建模、视频等)')}}</span>
                  </template>
                    <span v-if="DetForm.mainImageFileList&&DetForm.mainImageFileList.length==1" class="fileList">
                        <span style="cursor: pointer;" @click="handleViewFile(DetForm.mainImageFileList[0].filePath,DetForm.mainImageFileList[0].fileName)"> {{ DetForm.mainImageFileList[0].fileName }}</span>
                        <span style="margin-left:30px;cursor: pointer;" v-if="DetForm.status==0||DetForm.status==4" @click="DetForm.mainImageFileList=[]"> x </span>
                    </span>
                    <el-upload
                        v-else
                        :action="uploadFile"
                        ref="upload1"
                        :headers="headers"
                        :show-file-list="false"
                        :limit="1"
                        :on-remove="(res,file)=>{DetForm.mainImageFileList=[]}"
                        :on-success="(res,file)=>{successList( 'mainImageFileList',res,file)}"
                        >
                        <img src="../../../assets/upload.png" style="width: 88px;height: 88px;">
                    </el-upload>

                </el-form-item>
                <el-form-item prop="technicalAttachmentFileList" :label="$t('view.技术附件')">
                    <span v-if="DetForm.technicalAttachmentFileList&&DetForm.technicalAttachmentFileList.length==1" class="fileList">
                        <span style="cursor: pointer;" @click="handleViewFile(DetForm.technicalAttachmentFileList[0].filePath,DetForm.technicalAttachmentFileList[0].fileName)"> {{ DetForm.technicalAttachmentFileList[0].fileName }}</span>
                        <span style="margin-left:30px;cursor: pointer;" v-if="DetForm.status==0||DetForm.status==4" @click="DetForm.technicalAttachmentFileList=[]"> x </span>
                    </span>
                    <el-upload v-else
                        :action="uploadFile"
                        :limit="1"
                        ref="upload1"
                        :headers="headers"
                        :show-file-list="false"
                        :on-remove="(res,file)=>{DetForm.technicalAttachmentFileList=[]}"
                        :on-success="(res,file)=>{successList( 'technicalAttachmentFileList',res,file)}">
                        <el-button type="primary" size="mini">{{ $t('view.上传附件') }}</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" v-if="DetForm.status==0||DetForm.status==4" >
                <el-button size="mini"  @click="visibleOpen=false">{{ $t('view.取消') }}</el-button>
                <el-button size="mini" type="primary" @click="submit(DetForm.status==4?4: 0)">{{ $t('view.保存') }}</el-button>
                <el-button size="mini" type="primary" @click="submit(1)">{{ $t('view.提交') }}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="$t('view.选择物资')" :visible.sync="materialSelectVisible" width="88%" append-to-body :close-on-click-modal="false">
            <el-form :model="materialSelectQueryParams" ref="materialSelectQueryForm" size="small" :inline="true">
                <el-form-item :label="$t('view.物资编码')" prop="materialCode">
                    <el-input v-model="materialSelectQueryParams.materialCode" :placeholder="$t('view.请输入物资编码')" clearable @keyup.enter.native="handleMaterialSelectQuery" />
                </el-form-item>
                <el-form-item :label="$t('view.物资名称')" prop="materialName">
                    <el-input v-model="materialSelectQueryParams.materialName" :placeholder="$t('view.请输入物资名称')" clearable @keyup.enter.native="handleMaterialSelectQuery" />
                </el-form-item>
                <el-form-item :label="$t('view.规格')" prop="specificationName">
                    <el-input v-model="materialSelectQueryParams.specificationName" :placeholder="$t('view.请输入规格')" clearable @keyup.enter.native="handleMaterialSelectQuery" />
                </el-form-item>
                <el-form-item :label="$t('view.型号')" prop="model">
                    <el-input v-model="materialSelectQueryParams.model" :placeholder="$t('view.请输入型号')" clearable @keyup.enter.native="handleMaterialSelectQuery" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="handleMaterialSelectQuery">{{ $t('view.搜索') }}</el-button>
                    <el-button size="mini" @click="resetMaterialSelectQuery">{{ $t('view.重置') }}</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="materialSelectLoading" :data="materialSelectList" height="400" @current-change="handleMaterialSelectRowChange" @row-dblclick="confirmMaterialSelect" highlight-current-row>
                <el-table-column :label="$t('view.物资编码')" align="center" prop="materialCode" width="150" show-overflow-tooltip />
                <el-table-column :label="$t('view.物资名称')" align="center" prop="materialName" width="180" show-overflow-tooltip />
                <el-table-column :label="$t('view.规格')" align="center" prop="specificationName" width="120" show-overflow-tooltip />
                <el-table-column :label="$t('view.型号')" align="center" prop="model" width="120" show-overflow-tooltip />
                <el-table-column :label="$t('view.计量单位')" align="center" prop="masterUnit" width="100" />
                <el-table-column :label="$t('view.品牌')" align="center" prop="brandName" width="120" show-overflow-tooltip />
                <el-table-column :label="$t('view.是否进口')" align="center" prop="isImport" width="100">
                <template slot-scope="scope">
                    {{ getStatus('sys_supplier_material_import', scope.row.isImport) }}
                </template>
                </el-table-column>
                <el-table-column :label="$t('view.合同名称/招标项目')" align="center" prop="title" width="180" show-overflow-tooltip />
                <el-table-column :label="$t('view.供应商')" align="center" prop="supplierName" width="150" show-overflow-tooltip />
                <el-table-column :label="$t('view.商品介绍')" align="center" prop="details" width="150" show-overflow-tooltip />
                <el-table-column :label="$t('view.商品主图(包含图片、3D建模、视频等)')" align="center" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-for="(file,index) in scope.row.mainImageFileList" :key="index" class="fileLink" :title="file.fileName" @click="handleViewFile(file.filePath, file.fileName)">{{ file.fileName }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('view.技术附件')" align="center" width="180" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-for="(file,index) in scope.row.technicalAttachmentFileList" :key="index" class="fileLink" :title="file.fileName" @click="handleViewFile(file.filePath, file.fileName)">{{ file.fileName }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-show="materialSelectTotal>0" style="text-align: center;margin-top: 20px;" layout="prev, pager, next" :total="materialSelectTotal" @current-change="handleMaterialSelectCurrentChange"></el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmMaterialSelect">{{ $t('view.确定') }}</el-button>
                <el-button @click="materialSelectVisible = false">{{ $t('view.取消') }}</el-button>
            </div>
        </el-dialog>
    </div>
  </template>
<script>
import { uploadFile } from '@/utils/request'
import { getToken } from "@/utils/auth";
import {getSupplierMaterialApprove,batchSubmit,clientList,supplierMaterialApproveExport,supplierMaterialApproveImport,supplierMaterialApprovePut,listSupplierMaterialApprove} from '@/api/PersonalCenter'
import {getDicts} from '@/api/index'
import {handleViewFile} from '@/api/common/common.js'
import eventBus from '@/utils/eventBus.js'
  export default {
    data(){
        return{
            activeName : '0',
            visibleOpen:false,
            uploadFile,
            headers: {
                Authorization:getToken(),
            },
            total:0,
            rules:{
                specificationName: [{ required: true, trigger: 'blur', message: this.$t('view.请输入')}],
                model:[{ required: true, trigger: 'blur',  message: this.$t('view.请输入')}],
                brandName: [{ required: true, trigger: 'blur', message: this.$t('view.请输入')}],
                isImport:[{ required: true, trigger: 'blur',  message: this.$t('view.请选择')}],
                masterUnit: [{ required: true, trigger: 'blur', message: this.$t('view.请输入')}],
                details:[{ required: true, trigger: 'blur',  message: this.$t('view.请输入')}],
                mainImageFileList:[{ required: true, trigger: 'blur',  message: this.$t('view.请上传')}],
                technicalAttachmentFileList: [{ required: true, trigger: 'blur',  message: this.$t('view.请上传')}],
            },
            DetForm:{
                technicalAttachmentFileList:[],
                mainImageFileList:[],
            },
            form:{
                materialCode:'',
                materialName:'',
                pageNum:1,
                pageSize:10,
                statusList:'0', //列表状态 与选中tab保持一致
            },
            tableData:[],
            sys_supplier_material_approve_source:[],//来源
            sys_supplier_material_import:[],//是否进口
            stautsList:[{dictLabel:this.$t('view.未提交'),dictValue:'0',num:0},
                        {dictLabel:this.$t('view.审批驳回'),dictValue:'4',num:0},
                        {dictLabel:this.$t('view.审批中'),dictValue:'1',num:0},
                        {dictLabel:this.$t('view.审核通过'),dictValue:'3',num:0}],
            locale: localStorage.getItem('locale')||'zh',
            multipleSelection:[],
            // 物资选择弹窗
            materialSelectVisible:false,
            materialSelectLoading:false,
            materialSelectList:[],
            materialSelectTotal:0,
            materialSelectRow:null,
            materialSelectQueryParams:{
                pageNum:1,
                pageSize:10,
                materialCode:null,
                materialName:null,
                specificationName:null,
                model:null,
            },
        }
    },
    created(){
        this.clientList()
        this.getDicts('sys_supplier_material_approve_source')
        this.getDicts('sys_supplier_material_import')
    },
    methods:{
         /** 物资选择-行点击 */
        handleMaterialSelectRowChange(row) {
            this.materialSelectRow = row
        },
        /** 物资选择-查询 */
        handleMaterialSelectQuery() {
            this.materialSelectQueryParams.pageNum = 1
            this.getMaterialSelectList()
        },
        /** 物资选择-重置 */
        resetMaterialSelectQuery() {
            this.materialSelectQueryParams = {
                pageNum: 1,
                pageSize: 10,
                materialCode: null,
                materialName: null,
                specificationName: null,
                model: null
            }
            this.getMaterialSelectList()
        },
        /** 物资选择-分页 */
        handleMaterialSelectCurrentChange(e) {
            this.materialSelectQueryParams.pageNum = e
            this.getMaterialSelectList()
        },
        /** 确认选择物资 */
        confirmMaterialSelect() {
            if (!this.materialSelectRow) {
                this.$modal.msgError(this.$t('view.请选择一条物资信息'))
                return
            }
            const row = this.materialSelectRow
            this.DetForm.materialName = row.materialName
            this.DetForm.specificationName = row.specificationName
            this.DetForm.model = row.model
            this.DetForm.masterUnit = row.masterUnit
            this.DetForm.brandName = row.brandName
            this.DetForm.isImport = row.isImport
            this.DetForm.details = row.details
            // 加载附件
            this.loadMaterialAttachments(row.id)
            this.materialSelectVisible = false
        },
        /** 加载物资附件 */
        loadMaterialAttachments(id) {
            getSupplierMaterialApprove(id).then(response => {
                const data = response.data
                if (data.mainImageFileList && data.mainImageFileList.length > 0) {
                    this.DetForm.mainImageFileList = data.mainImageFileList
                }
                if (data.technicalAttachmentFileList && data.technicalAttachmentFileList.length > 0) {
                    this.DetForm.technicalAttachmentFileList = data.technicalAttachmentFileList
                }
            })
        },
        getMaterialSelectList() {
            this.materialSelectLoading = true
            const queryParams = {
                ...this.materialSelectQueryParams,
                statusList: ['1', '2', '3', '4'],
                isHistoryData: '0'
            }
            listSupplierMaterialApprove(queryParams).then(response => {
                this.materialSelectList = response.rows
                this.materialSelectTotal = response.total
                this.materialSelectLoading = false
            })
        },
         /** 打开物资选择弹窗 */
        openMaterialSelect() {
            this.materialSelectVisible = true
            this.materialSelectRow = null
            this.resetMaterialSelectQuery()
        },
        // 附件查看与下载（使用系统统一方法 @/api/common/common.js）
        handleViewFile,
        async getNum(){
           let num1 = await clientList({statusList:0})
           let num2 = await clientList({statusList:4})
            this.stautsList[0].num=num1.total>99?'99+':num1.total
            this.stautsList[1].num=num2.total>99?'99+':num2.total
            let total=num1.total+num2.total
            eventBus.$emit('HandlingMattersNum',total>99?'99+':total) //传入top 处理事项的数量
        },
        // 批量提交
        batch(){
            if(this.multipleSelection.length==0) return this.$message({  message: this.$t('view.请选择要提交的数据'),type: "warning",});

            let ids=[]
            for(var i in this.multipleSelection){
                ids.push(this.multipleSelection[i].id)
            }
            this.batchSubmit(ids.join(','))
        },
        batchSubmit(id){
            batchSubmit(id).then(res=>{
                console.log(res)
                if(res.code==200) {
                    this.$message.success(this.$t('view.操作成功'))
                    this.handleCurrentChange(1)
                }
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        successList(list,res, file){
            this.$set(this.DetForm,list,[{
                name:file.response.originalFilename,
                fileName:file.response.originalFilename,
                filePath:file.response.fileName,
                url: file.response.url,
                type:file.response.originalFilename.split(".").pop(),
                fileSize:file.size
            }])
        },
        Det(item){
            this.DetForm=JSON.parse(JSON.stringify(item))

            this.visibleOpen=true
        },
        // 导入
        importFile(param) {
            const formData = new FormData();
            formData.append("file", param.file);
            const loading = this.$loading({
                lock: true,
                text: this.$t('view.导入中'),
                spinner: 'el-icon-loading',
            });
            supplierMaterialApproveImport(formData).then((response) => {
                if (response.code == 200) {
                    this.clientList()
                    this.$modal.msgSuccess(this.$t('view.导入成功'));
                    loading.close();


                } else {
                    this.$message({  message: this.$t('view.操作失败'),type: "warning",});
                    loading.close();
                }

            }).catch((err)=>{
                loading.close();
            });
        },
        // 导出
        supplierMaterialApproveExport(){
            this.download('material/supplierMaterialApprove/export',{statusList:this.activeName},this.$t('view.模板.xlsx'))
            // supplierMaterialApproveExport().then(res=>{
            //     const blob = new Blob([res]);
            //     const url = URL.createObjectURL(blob);
            //     const link = document.createElement('a');
            //     link.href = url;
            //     console.log('123',url)
            //     link.download = this.$t('view.模板.xlsx');
            //     link.click();
            // })
        },
        resetting(){
            this.form={
                materialCode:'',
                materialName:'',
                pageNum:1,
                pageSize:10,
                statusList:'0',
            }
            this.clientList()
        },
        handleCurrentChange(e){
            this.form.pageNum=e
            this.clientList()

        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        clientList(){
            this.getNum()
            this.form.statusList=this.activeName==1?[1,2]:this.activeName
            clientList(this.form).then(res=>{
                this.tableData=res.rows
                this.total=res.total

            })
        },
        submit(status){
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.DetForm.status=status
                    supplierMaterialApprovePut(this.DetForm).then(res=>{
                        if(res.code==200)
                        this.$message.success(this.$t('view.操作成功'))
                        this.visibleOpen=false
                        this.handleCurrentChange(1)
                    })
                }
            })

        },
    }
};
</script>
<style lang="scss" scoped>
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
    .fileList{
        background: rgba(224,32,32,0.1);
        border-radius: 6px;
        padding: 8px 10px;
        color: #E02020;
        font-size: 14px;
    }
    // 表格中的附件名称（超长名称省略显示，悬浮 title 查看全称）
    .fileLink{
        display: block;
        max-width: 100%;
        color: #409EFF;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .tab-badge {
        display: inline-block;
        height: 18px;
        padding: 0 2px;
        background: #E02020;
        border-radius: 7px 7px 7px 2px;
        color: white;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        position: absolute;
        right: 14px;
        top: 0;
        cursor: pointer;
        transform: translateX(50%);
    }
</style>
<style lang="scss">
.flex30{
    display: flex;
    flex-wrap: wrap;
    .el-input__inner{width: 100%;}
    .el-cascader{width: 100%;}
    .el-form-item{width: 32%;margin-right: 2%;}
    .el-form-item:nth-child(3n){margin-right: 0;}
    .el-form-item__label{
        font-size: 13px;
        padding: 0 !important;
    }
    .switchBox .el-form-item__content{
        background: #F3F4F5;
        border-radius: 4px;
        padding-left: 10px;
    }
}
.HandlingMatters .el-dialog__body{padding: 10px 20px;}
.HandlingMatters .el-form-item__label{
    font-size: 13px;
    padding: 0 !important;
}
</style>
